import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import BalancoService from '../../../services/balanco'
import InfiniteScroll from '../../auth/utils/infiniteScroll';
import Balanco from './balanco';


const ListarBalancos = () => {


    async function fetchBalancos() {
        await seraQueAcabou();
        const response = await BalancoService.tipos({ limit: true, cod_balanco: cod, tipo:"Patrimonial"});
        if (response.data.length >= 1) {
            let count = Math.floor(numBalancos / 20)+1
            for (let i = 1; i < count; i++) {
                setBalancos([...balancos, ...response.data])
                setCod(response.data[response.data.length-1]["cod_balanco"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setBalancos([])
            setVazio(true)
        }
    }

    const [balancos, setBalancos] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [cod, setCod] = useState(null);
    const [numBalancos, setNumBalancos] = useState(null);
    const [aindaTem, setAindaTem] = useState();



    async function fetchBalancosIn() {
        await pegaNumBalancos();
        const response = await BalancoService.tipos({tipo: "Patrimonial", limit: true});
        if (response.data.length >= 1) {
            setBalancos(response.data)
            setVazio(false)
            setCod(response.data[response.data.length-1]["cod_balanco"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setBalancos([])
            setVazio(true)
        }
    }

    async function pegaNumBalancos() {
        const response = await BalancoService.numBalancos({ todas: false, tipo: "Patrimonial" })
        setNumBalancos(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (balancos.length >= numBalancos+1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }


    useEffect(() => {
        fetchBalancosIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setBalancos={setBalancos}
                    setVazio={setVazio}
                    setAindaTem={setAindaTem}
                    fetchBalancosIn={fetchBalancosIn}
                    balancos={balancos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {balancos.map((balanco, index) =>
                            <Balanco
                                balanco={balanco}
                                key={balanco.cod_balanco}
                            />
                        )}
                    </Row>
                    {aindaTem ?
                        <Fragment>
                            <p>Carregando mais balanços...</p>
                            <InfiniteScroll Listar={fetchBalancos} />
                        </Fragment>
                        : <p>Todos as balanços já foram exibidos :)</p>}
                </Fragment>}
        </Fragment>

    )
}

export default ListarBalancos;